/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

import React from 'react';
import Sharing from '../Sharing';

class RiskAndSensationOverlay extends React.Component {
  render() {
    return <div className="overlay">
      <Sharing
        classes="sharing"
        hash="riskSensation"
        url={'http://guidesaventure.ca/episode/' + this.props.episode + '/risk/' + this.props.episode + '_' + this.props.page + ''}
        twitterText="À voir"
      />
      <button className="arrow_btn left" onClick={this.props.prev}>next</button>
      <button className="arrow_btn right" onClick={this.props.next}>previous</button>
      <ul className="image-gallery-bullets">
        <li><button className="image-gallery-bullet active" onClick={() => this.props.select(0)}>page1</button></li>
        <li><button className="image-gallery-bullet" onClick={() => this.props.select(1)}>page2</button></li>
        <li><button className="image-gallery-bullet" onClick={() => this.props.select(2)}>page3</button></li>
      </ul>
    </div>
  }
}

RiskAndSensationOverlay.propTypes = {
  next: React.PropTypes.func,
  prev: React.PropTypes.func,
  select: React.PropTypes.func
};

RiskAndSensationOverlay.defaultProps = {
  next: () => alert("null"),
  prev: () => alert("null"),
  select: (page) => alert("null")
};


export default RiskAndSensationOverlay;



// WEBPACK FOOTER //
// ./src/components/riskAndSensation/RiskAndSensationOverlay.js